import { Button } from '@mui/material'
import React, { useRef } from 'react'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateAlert } from '../../redux/actions';

function PerformanceArea({groundTruth, setGroundTruth, showPDF, handlePDF, result, handleAlert}) {

  const navigate = useNavigate();
  const GTRef = useRef(null)

  const handleTryAgain = () => {
    navigate(`/m2d/models/${result.m2dModelId}`);
  };

  const handleGT = () => {
    GTRef.current.click()
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsText(file);

    reader.onload = () => {
      if (file.type === "application/json") {
        const content = JSON.parse(reader.result);
        if (
          result.value &&
          Object.keys(JSON.parse(result.value).results).length === content.length &&
          content.every(
            (c) =>
              c.hasOwnProperty("filename") && c.hasOwnProperty("groundTruth")
          )
        ) {
          setGroundTruth(content);
        } else {
          handleAlert("error", "Wrong format!", 3000);
        }
      } else {
        handleAlert("error", "Please upload JSON file!", 3000);
      }
    };
  };

  return (
    <>
      <div className="done-result-btn-area">
        <label htmlFor="file-upload" className="custom-file-upload">
          <Button
            variant="contained"
            color="primary"
            onClick={handleGT}
            style={{ marginBottom: "10px" }}>
            Provide labels
          </Button>
        </label>

        <input
          id="file-upload"
          type="file"
          onChange={handleFileUpload}
          ref={GTRef}
          style={{ display: "none" }}
        />
        {groundTruth.length > 0 ? <Button
          variant="outlined"
          color="primary"
          onClick={handlePDF}
          style={{ marginLeft: "8px", marginBottom: "10px" }}
        >
          {showPDF ? "Close PDF" : "Generate PDF"}
        </Button> : null}
        <Button
          variant="outlined"
          color="primary"
          onClick={handleTryAgain}
          style={{ marginLeft: "8px", marginBottom: "10px" }}
        >
          Try again
        </Button>
      </div>
      {groundTruth.length === 0 ? (
        <div className="ground-truth-example-file">
          Please generate your label file in JSON format. See this{" "}
          <a
            className="link"
            href="https://github.com/hulab-emory/m2d-files/blob/main/example_files/groundtruth.json"
            download
          >
            example
          </a>
          .
        </div>
      ) : null}
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(null, mapDispatchToProps)(PerformanceArea);
